import type { TFavoriteProductFromApi } from '../models';
import type { IProductEntity } from '@/entities';

import { ProductMM } from '@/entities';

interface IFavoriteProductOptions {
  favoriteProductFromApi?: TFavoriteProductFromApi;
  product?: IProductEntity;
}

export class FavoriteProduct extends ProductMM {
  /** для UI */
  public isRemoving = false;
  public setRemovingState(value: boolean) {
    this.isRemoving = value;
  }

  constructor(options: IFavoriteProductOptions) {
    super(options.product);

    if (!options.favoriteProductFromApi) return;
    this.setProduct(this.mapProduct(options.favoriteProductFromApi));
  }

  private mapProduct(favoriteProductFromApi: TFavoriteProductFromApi): IProductEntity {
    return {
      id: favoriteProductFromApi.productId,
      fullPrice: favoriteProductFromApi.promotion?.oldPrice ?? favoriteProductFromApi.price,
      sellPrice: favoriteProductFromApi.price,
      photo: {
        link: {
          high: favoriteProductFromApi.gallery?.[0]?.url,
          low: favoriteProductFromApi.gallery?.[0]?.url,
        },
      },

      isFavorite: favoriteProductFromApi.isInFavorites,
      isAdult: favoriteProductFromApi.isForAdults,

      /** не приходит этот  параметр, как и дата доставки */
      inStock: true,

      title: favoriteProductFromApi.name,
      rating: favoriteProductFromApi.ratings?.rating,
      feedbackQuantity: favoriteProductFromApi.ratings?.commentsCount,

      badges: favoriteProductFromApi.badges.map((it, index) => ({
        id: `${favoriteProductFromApi.productId}-bage-${index}`,
        text: it.text,
        textColor: it.textColor,
        backgroundColor: it.backgroundColor,
      })),
    };
  }
}
